import React from 'react';

import Icon from '../Icon/Icon';

const DamageIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <g clipPath='url(#clip0_6443_654)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M34.7375 7.79303C35.1171 7.87365 35.4157 8.16655 35.5037 8.54447L36.9774 14.8744L47.3618 12.4331C47.7736 12.3363 48.2017 12.5091 48.431 12.8646C48.6603 13.22 48.6411 13.6813 48.3831 14.0165L42.0929 22.189L49.3094 26.9199C49.6359 27.1339 49.808 27.5183 49.7502 27.9043C49.6924 28.2903 49.4152 28.6074 49.0404 28.7164L42.1467 30.7211C41.6164 30.8753 41.0615 30.5705 40.9072 30.0401C40.753 29.5098 41.0579 28.9549 41.5882 28.8007L46.3972 27.4022L40.0943 23.2703C39.8615 23.1176 39.7028 22.8749 39.6565 22.6004C39.6101 22.326 39.6803 22.0446 39.85 21.824L45.0846 15.023L36.4595 17.0507C36.201 17.1115 35.9289 17.0669 35.7032 16.9268C35.4776 16.7867 35.3169 16.5626 35.2567 16.304L34.0399 11.0775L31.8742 13.9425C31.5411 14.3831 30.914 14.4702 30.4734 14.1372C30.0328 13.8042 29.9457 13.177 30.2787 12.7364L33.7321 8.16819C33.966 7.85865 34.358 7.71242 34.7375 7.79303Z'
                    fill='#393E44'
                />
                <path
                    d='M37.7939 54.2427C32.9376 57.0464 26.728 55.3825 23.9242 50.5263L9.70934 25.9055C6.90557 21.0492 8.56949 14.8396 13.4257 12.0358L16.0635 10.5128C17.1335 9.89509 18.2769 9.51792 19.4301 9.36528C19.8121 9.31486 20.1778 9.51587 20.3705 9.84961L20.5575 10.1735C23.1712 9.4452 26.0455 10.5403 27.4648 12.9987L43.8452 41.3704C45.2642 43.8287 44.7752 46.8648 42.8378 48.7641L43.1595 49.3214C43.3522 49.6552 43.3435 50.0724 43.1088 50.378C42.4 51.3003 41.5017 52.102 40.4317 52.7197L37.7939 54.2427Z'
                    fill='#393E44'
                />
                <path
                    d='M20.3379 9.79492C20.3496 9.81259 20.3608 9.8307 20.3715 9.84921L20.5585 10.1731C21.0952 10.0235 21.6429 9.95089 22.1867 9.95112L43.8453 47.4649C43.5736 47.936 43.2368 48.374 42.839 48.764L43.1607 49.3212C43.1714 49.3397 43.1814 49.3585 43.1909 49.3775L20.3379 9.79492Z'
                    fill='#FFFDFB'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M28.5147 20.9099L31.1526 19.3869L32.168 21.1455L29.53 22.6685L28.5147 20.9099Z'
                    fill='#00D1D2'
                />
                <path
                    d='M33 44C33 37.9249 37.9249 33 44 33C50.0751 33 55 37.9249 55 44C55 50.0751 50.0751 55 44 55C37.9249 55 33 50.0751 33 44Z'
                    fill='#FFFDFB'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M44 53.75C49.3848 53.75 53.75 49.3848 53.75 44C53.75 38.6152 49.3848 34.25 44 34.25C38.6152 34.25 34.25 38.6152 34.25 44C34.25 49.3848 38.6152 53.75 44 53.75ZM56.25 44C56.25 50.7655 50.7655 56.25 44 56.25C37.2345 56.25 31.75 50.7655 31.75 44C31.75 37.2345 37.2345 31.75 44 31.75C50.7655 31.75 56.25 37.2345 56.25 44Z'
                    fill='#393E44'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M44 38C44.5523 38 45 38.4477 45 39L45 45.8C45 46.3523 44.5523 46.8 44 46.8C43.4477 46.8 43 46.3523 43 45.8L43 39C43 38.4477 43.4477 38 44 38Z'
                    fill='#393E44'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M44 48C44.5523 48 45 48.4477 45 49L45 49.4C45 49.9523 44.5523 50.4 44 50.4C43.4477 50.4 43 49.9523 43 49.4L43 49C43 48.4477 43.4477 48 44 48Z'
                    fill='#393E44'
                />
            </g>
            <defs>
                <clipPath id='clip0_6443_654'>
                    <rect width='64' height='64' fill='white' />
                </clipPath>
            </defs>
        </Icon>
    );
};

export default DamageIcon;
